<template>
  <div>

    <Row :gutter="10">
      <span class="select-count" v-if="selectedRows.length">{{selectedRows.length}} Selected</span>
      <Button v-show="selectedRows.length" @click="onBulkPrint" id="print-btn">Print</Button>
      <DatePicker v-model="filterDate" type="daterange" :options="dateOptions" placeholder="Select date" :clearable="false"
                  format="dd/MM/yyyy" class="filterInput" style="width: 260px; float: right"/>
    </Row>

    <hot-table :settings="hotSettings" ref="hotTableComponent" style="margin: 20px 0 0 0">
      <hot-column v-for="(colset, index) in isAdmin?[...columns, actionObj]:[...columns]" :settings="colset" :key="index"/>
    </hot-table>

    <manage-order :orderId="orderId" ref="manage-order-page" :viewPath="viewPath"/>
    <DownloadLR :dialog.sync="downloadLRDialog" :lr.sync="lr"/>
    <LRForm :formDialog.sync="lrFormDialog" :orderId="lrOrderId" :lrId.sync="lrId"/>
  </div>
</template>

<script>
import { HotTable, HotColumn } from '@handsontable/vue';
import {Constants} from "../../Constants/Constant";
import moment from 'moment';
import {dateOptions} from "../ExcelFormattedOrders/Settings";
import {SUBSCRIBE_LR} from "../../graphql/subscription/lr";
import ManageOrder from "../Manage Order/ManageOrder";
import {
  lrNumberRenderer,
  orderNumberRenderer,
  orderDetailsRenderer,
  truckDriverRenderer,
  consignorRenderer,
  consigneeRenderer,
  pickupPointRenderer,
  dropPointRenderer,
  lrStatusRenderer,
  actionRenderer,
  lrPrintRenderer
} from "./RendererFunctions";
import {getAllNumbersBetween, getLRStatus, getVehicleDetails, hotSettingsExcelLR, isLREditable} from "./Settings";
import {generate_UPDATE_ORDER_DATA} from "../../graphql/mutations/orders";
import DownloadLR from "./DownloadLR";
import LRForm from "./LRForm";

export default {
  name: "ExcelLR",
  props:['globalSearch'],
  components: {LRForm, DownloadLR, ManageOrder, HotTable, HotColumn},
  provide() {
    return {
      getManageOrderDrawer: () => this.manageOrderDrawer,
      setManageOrderDrawer: (data) => { this.manageOrderDrawer = data },
      getOrder: () => this.order,
      closeAssignVehicleDialog: (data) => { },
    }
  },
    apollo: {
      $subscribe: {
        lr: {
          query: SUBSCRIBE_LR,
          fetchPolicy: 'network-only',
          variables() { return {
            startDate: moment(this.filterDate[0], 'DD/MM/YYYY').format('YYYY-MM-DDT00:00:00+05:30'),
            endDate: moment(this.filterDate[1], 'DD/MM/YYYY').format('YYYY-MM-DDT23:59:59+05:30'),
            search: '%' + this.globalSearch + '%'
          }},
          result ({ data }) { this.lrArr = data.lr; this.prepareSheetData(data.lr) }
        }
      }
    },
    data(){
      return{
        Constants: Constants,
        moment: moment,
        lrArr: [],
        columns: [
          {title: '', data: 'print', renderer: (...args) => lrPrintRenderer(...args, this, 'lrArr') },
          {title: 'LR No', data: 'lrNumber', renderer: (...args) => lrNumberRenderer(...args, this, 'lrArr') },
          {title: 'LR Date', data: 'createdAt', type: 'date', dateFormat: 'DD MMM \'YY' },
          {title: 'Order No', data: 'orderNumber', renderer: (...args) => orderNumberRenderer(...args, this, 'lrArr') },
          {title: 'Consignor', data: 'consignor', renderer: (...args) => consignorRenderer(...args, this, 'lrArr')},
          {title: 'Consignee', data: 'consignee', renderer: (...args) => consigneeRenderer(...args, this, 'lrArr')},
          {title: 'Pickup Point', data: 'pickupPartyName', renderer: (...args) => pickupPointRenderer(...args, this, 'lrArr')},
          {title: 'Drop Point', data: 'dropPartyName', renderer: (...args) => dropPointRenderer(...args, this, 'lrArr')},
          {title: 'Item', data: 'boxes', renderer: (...args) => orderDetailsRenderer(...args, this, 'lrArr') },
          {title: 'Weight <br> (Kg)', data: 'kg'},
          {title: 'Truck No', data: 'truckPlateNumber'},
          {title: 'Driver <br> Details', data: 'truckDriverName', renderer: (...args) => truckDriverRenderer(...args, this, 'lrArr') },
          {title: 'Status', data: 'status', renderer: lrStatusRenderer }
        ],
        actionObj: {title: 'Action', data: 'action', renderer: (...args) => actionRenderer(...args, this, 'lrArr')},
        hotSettings: hotSettingsExcelLR([50, 90, 90, 90, 120, 120, 120, 120, 100, 80, 100, 100, 80, 100], this),
        dateOptions,
        filterDate: [moment().subtract(7, 'days').format('DD/MM/YYYY'), moment().format('DD/MM/YYYY')],
        manageOrderDrawer: false,
        orderId: 'aa00aa00-000a-0000-aaaa-aaaaaa00000a',
        currentOrderStatus: '',
        order: '',
        viewPath: '',
        downloadLRDialog: false,
        lr: null,
        selectedRows: [],
        lrFormDialog: false,
        lrOrderId: null,
        lrId: null,
      }
    },
    computed: {
      isAdmin: function(){
        return this.$store.state.userObj.role[0].id === Constants.adminRoleId
      }
    },
    methods:{
      prepareSheetData(data) {
        let mainArr = [];
        data.forEach(curnt => {
          curnt.obj = {
            print: '',
            lrNumber: curnt.lrNumber,
            createdAt: moment(curnt.created_at).format('DD MMM \'YY'),
            orderNumber: curnt.Order.orderNumber,
            consignor: curnt.Consignor.name,
            consignee: curnt.Consignee.name,
            pickupPartyName: curnt.PickupCompany.name,
            dropPartyName: curnt.DropCompany.name,
            boxes: curnt.Order.materials.boxes,
            kg: curnt.Order.materials.kg,
            truckPlateNumber: getVehicleDetails(curnt.Order, curnt.transportVehicle, 'platNo'),
            truckDriverName: getVehicleDetails(curnt.Order, curnt.transportVehicle, 'driverName'),
            status: getLRStatus(curnt, curnt.Order),
            action: ''
          }
          mainArr.push(curnt.obj)
        })
        this.hotSettings.data = mainArr
      },
      editOrder(order){
        this.orderId = order.id;
        this.viewPath = order.internalStatus.viewPath;      //Load form based on internalStatus.viewPath
        this.order = order;
        this.currentOrderStatus = order.internalStatus.id;
        this.manageOrderDrawer = true;
      },
      editLR(order, lr){
        if(isLREditable(lr, order)){                     //Check Edit LR permission
          this.lrOrderId = order.id;
          this.lrId = lr.id
          this.lrFormDialog = true
        }
      },
      openDownloadPDF(row){
        this.lr = row;
        this.downloadLRDialog = true;
      },
      onBulkPrint(){
        let lrArr = this.selectedRows.map(row => this.lrArr[row])
        this.lr = lrArr;
        this.downloadLRDialog = true;
      },
      afterSelection(){
        let hotInstance = this.$refs['hotTableComponent'].hotInstance
        let rowArr = []
        hotInstance.getSelectedRange().forEach((curnt) => {
          if(curnt.from.row === curnt.to.row) rowArr.push(curnt.from.row)
          else rowArr.push(...getAllNumbersBetween(curnt.from.row, curnt.to.row))
        })
        this.selectedRows = [...new Set(rowArr)].map(row => hotInstance.toPhysicalRow(row))      //Remove duplicate values from array
      },
      resetSelection(){
        this.selectedRows = []
      },
      onChangeLRStatus(row){
        if(!this.isAdmin) return                                        //Only Admin can change LR Status
        this.$Modal.confirm({
          title: 'Confirmation',
          content: `<p>Are you sure want to ${row.status==='ACTIVE'?'cancel':'revert status of'} LR ?</p>`,
          loading: true,
          onOk: async () => {
            let obj = {status: row.status==='ACTIVE'?'INACTIVE':'ACTIVE'}
            await this.updateRecord(row.id, obj, 'lr')
            this.$Message.success('LR status updated successfully!')
            this.$Modal.remove();
          },
          onCancel: () => console.log('canceled')
        });
      },
      async updateRecord(id, obj, table){
        let response = await this.$apollo.mutate({
          mutation: generate_UPDATE_ORDER_DATA(table),
          variables: { id: id, obj: obj}
        })
        if(response.data) return Promise.resolve(response.data)
      },
    }
}
</script>

<style scoped>
/deep/ .ivu-date-picker-cells  {
  font-size: 12px !important;
}
/deep/ .ivu-picker-panel-sidebar  {
  width:125px !important;
  margin-left:-116px !important;
}
/deep/ .handsontable > .ht_master{
  font-size: 14px;
}
/deep/ .handsontable > .ht_master > .wtHolder{
  width: unset !important;
  height: unset !important;
}
/deep/ .handsontable span.colHeader {
  font-size: 13px;
}
/deep/.handsontable td{
  vertical-align: middle !important;
  padding: 0 1px 0 1px !important;
  white-space: unset !important;
  font-size: 13px;
}

/deep/.handsontable th{
  background-color: #d9d9d9;
  color: #222;
  text-align: center;
  font-weight: 600;
  vertical-align: middle !important;
  white-space: nowrap !important;
  padding: 0 0px 0 0px !important;
}
</style>
<style>
  .select-count{
    margin: 0 10px 0 10px;
  }
  .order-num-txt:hover {
    text-decoration: underline;
    cursor: pointer;
  }
  .green-text{
    color: green !important;
  }
  .red-text{
    color: red !important;
  }
  .action-text{
    text-decoration: underline;
    color: orange;
    cursor: pointer;
  }
  .fa-print{
    cursor: pointer;
  }
</style>
<style src="../../../node_modules/handsontable/dist/handsontable.full.css"></style>
